import React from 'react';
import { AlertTriangle, X, Calendar } from 'lucide-react';

export default function SwitchPlanModal({
    isOpen,
    onClose,
    selectedSwitchPlan,
    billingCycle,
    proPriceYearly,
    proPriceMonthly,
    standardPriceYearly,
    standardPriceMonthly,
    onConfirm,
    processing,
    subscription
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose}></div>
            <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-scale-in">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors"
                >
                    <X className="w-5 h-5" />
                </button>

                <div className="flex flex-col items-center text-center mb-6">
                    <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                        <AlertTriangle className="w-8 h-8 text-blue-500" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">Confirm Plan Switch</h3>
                    <p className="text-slate-600">
                        You are about to switch your subscription to <strong>{selectedSwitchPlan} {billingCycle === 'yearly' ? 'Yearly' : 'Monthly'}</strong>.
                    </p>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 mb-6 border border-slate-100 space-y-2.5">
                    <div className="flex justify-between items-center">
                        <span className="text-slate-600 font-medium">New Plan Rate</span>
                        <span className="text-slate-900 font-bold">
                            ${selectedSwitchPlan === 'Professional'
                                ? (billingCycle === 'yearly' ? proPriceYearly : proPriceMonthly)
                                : (billingCycle === 'yearly' ? standardPriceYearly : standardPriceMonthly)
                            }/{billingCycle === 'yearly' ? 'yr' : 'mo'}
                        </span>
                    </div>

                    <div className="flex justify-between items-center">
                        <span className="text-slate-600 font-medium">Billed</span>
                        <span className="text-slate-900 font-bold capitalize">{billingCycle}</span>
                    </div>

                    <div className="h-px bg-slate-200 my-1"></div>

                    <div className="flex justify-between items-center">
                        <span className="text-slate-500 font-medium text-sm flex items-center gap-1.5">
                            <Calendar className="w-3.5 h-3.5 text-indigo-400" />
                            Renews On
                        </span>
                        <span className="text-slate-800 font-semibold text-sm">
                            {subscription?.current_period_end
                                ? new Date(subscription.current_period_end).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
                                : '—'}
                        </span>
                    </div>


                </div>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 py-3 px-4 bg-white border border-slate-200 text-slate-700 font-semibold rounded-xl hover:bg-slate-50 hover:border-slate-300 transition-all"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={processing}
                        className="flex-1 py-3 px-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg shadow-blue-200 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center gap-2"
                    >
                        {processing ? (
                            <>
                                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                                <span>Processing...</span>
                            </>
                        ) : (
                            'Confirm Switch'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
